import { inject, NgModule } from '@angular/core';
import { NZ_ICONS, NzIconService } from 'ng-zorro-antd/icon';
import { STATIC_NZ_ICONS } from './nz-icons.constants';

const CUSTOM_ICONS: { name: string; icon: string }[] = [
  { name: 'ai-tutor', icon: 'assets/icons/ai-tutor.svg' },
  { name: 'ai-tutor-white', icon: 'assets/icons/ai-tutor-white.svg' },
  { name: 'math-user', icon: 'assets/icons/math-user.svg' },
  { name: 'math-rocket', icon: 'assets/icons/rocket.svg' },
  { name: 'math-magic-wand', icon: 'assets/icons/magic-wand.svg' },
  { name: 'math-ai-sparkle', icon: 'assets/icons/ai-sparkle.svg' },
  { name: 'math-check', icon: 'assets/icons/check.svg' },
];

@NgModule({
  providers: [{ provide: NZ_ICONS, useValue: STATIC_NZ_ICONS }],
})
export class NzIconsModule {
  private readonly iconService = inject(NzIconService);

  constructor() {
    CUSTOM_ICONS.forEach((icon) => this.iconService.addIcon(icon));
  }
}
